"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = "\n  :root {\n    --shadow-1: 0px 1px 4px rgba(12, 12, 13, 0.1);\n    --shadow-2: 0px 2px 8px rgba(12, 12, 13, 0.1);\n    --shadow-3: 0px 4px 16px rgba(12, 12, 13, 0.22);\n    --shadow-4: 0px 8px 18px rgba(12, 12, 13, 0.3);\n  }\n";
